var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._t("header")],2),_c('div',{staticClass:"card-content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }